import { resolveComponent as e, createBlock as n, openBlock as i, withCtx as o, createVNode as c, createElementVNode as p, createCommentVNode as _, toDisplayString as f, renderSlot as k } from "vue";
import { _ as y } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
import b from "../keyboard-shortcut/keyboard-shortcut.js";
import S from "../stack/stack.js";
import g from "../tooltip/tooltip.js";
import h from "../button/button.js";
const x = {
  compatConfig: { MODE: 3 },
  name: "DtRecipeMessageInputButton",
  components: {
    DtButton: h,
    DtTooltip: g,
    DtStack: S,
    DtKeyboardShortcut: b
  },
  props: {
    ariaLabel: {
      type: String,
      required: !0
    },
    tooltipText: {
      type: String,
      required: !0
    },
    keyboardShortcutText: {
      type: String,
      default: ""
    },
    isActive: {
      type: Boolean,
      default: !1
    },
    dataQa: {
      type: String,
      required: !0
    }
  },
  emits: ["click"]
};
function D(r, a, t, v, B, T) {
  const d = e("dt-button"), l = e("dt-keyboard-shortcut"), u = e("dt-stack"), s = e("dt-tooltip");
  return i(), n(s, null, {
    anchor: o(() => [
      c(d, {
        "data-qa": t.dataQa,
        importance: "clear",
        kind: "muted",
        "aria-label": t.ariaLabel,
        size: "xs",
        active: t.isActive,
        onClick: a[0] || (a[0] = (m) => r.$emit("click", m))
      }, {
        icon: o(() => [
          k(r.$slots, "icon")
        ]),
        _: 3
      }, 8, ["data-qa", "aria-label", "active"])
    ]),
    default: o(() => [
      c(u, { gap: "200" }, {
        default: o(() => [
          p("p", null, f(t.tooltipText), 1),
          t.keyboardShortcutText ? (i(), n(l, {
            key: 0,
            inverted: "",
            shortcut: t.keyboardShortcutText
          }, null, 8, ["shortcut"])) : _("", !0)
        ]),
        _: 1
      })
    ]),
    _: 3
  });
}
const E = /* @__PURE__ */ y(x, [["render", D]]);
export {
  E as default
};
//# sourceMappingURL=message-input-button.js.map
